import state from './state'
import mutations from './mutations'
import actions from './actions'
import getters from './getters'

export default {
    firestorePath: '/workedHours',
    firestoreRefType: 'collection',
    moduleName: 'workedHours',
    statePropName: 'workedHours',
    namespaced: true,
    serverChange: {
        convertTimestamps: {
            created_at: '%convertTimestamp%', // default
        },
    },
    state,
    getters,
    mutations,
    actions
}